export const CatalogCards = {
  en: {
    'Search folders and cards…': 'Search folders and cards…',
    'Expand all': 'Expand all',
    'Collapse tree': 'Collapse',
    'No results.': 'No results.',
    'No selection': 'No selection',
    Status: 'Status',
    'Reset filters': 'Reset filters',
    'Select a folder or card from the tree on the left to see details.':
      'Select a folder or card from the tree on the left to see details.',
    'Create Category': 'Create Folder',
    'Create Root Category': 'Create Root Folder',
    'Create Subcategory': 'Create Subfolder',
    'Category name': 'Folder name',
    'Parent category': 'Parent folder',
    'Edit Category': 'Edit Folder',
    'Create subcategory': 'Create subfolder',
    Rename: 'Rename',
    'Maximum category depth': 'Maximum nesting depth reached',
    'Category not empty': 'Folder is not empty',
    'Confirm deletion': 'Confirm deletion',
    'Delete category confirm': 'Delete this folder? This cannot be undone.',
    'Category created': 'Folder created',
    'Category updated': 'Folder updated',
    'Category archived': 'Folder archived',
    'Category restored': 'Folder restored',
    'Category deleted': 'Folder deleted',
    'Move to': 'Move to…',
    Move: 'Move',
    'Move Category': 'Move Folder',
    'Move Card': 'Move Card',
    'Select destination category': 'Select destination folder',
    'Cannot move category depth':
      'Cannot move here — maximum nesting depth would be exceeded',
    'Category moved': 'Folder moved',
    'Card moved': 'Card moved',
    Subcategories: 'Subfolders',
    'This category is empty': 'This folder is empty',
    'direct cards': 'direct cards',
    'cards total': 'cards total',
    'Drag to reorder': 'Drag to reorder',
    'Add card': 'Add card',
    Card: 'Card',
    Cards: 'Cards',
    'Create Card': 'Create Card',
    'Edit Card': 'Edit Card',
    'Card created': 'Card created',
    'Card updated': 'Card updated',
    'Card archived': 'Card archived',
    'Card restored': 'Card restored',
    'Card deleted': 'Card deleted',
    'Delete card confirm': 'Delete this card? This cannot be undone.',
    Category: 'Folder',
    Folder: 'Folder',
    'Business direction': 'Business direction',
    'Price change reason': 'Price change reason',
    'Price history': 'Price history',
    'No price changes': 'No price changes',
    Remove: 'Remove',
    'Selling permissions': 'Selling permissions',
    'Specify staff member': 'Specify staff member',
    'Anyone with sales permission can sell': 'Anyone with sales permission',
    // Tabs
    General: 'General',
    'Discount services': 'Discounts',
    'Who sells': 'Selling permission',
    'Active schedule': 'Active schedule',
    Monday: 'Mon',
    Tuesday: 'Tue',
    Wednesday: 'Wed',
    Thursday: 'Thu',
    Friday: 'Fri',
    Saturday: 'Sat',
    Sunday: 'Sun',
    Weekday: 'Weekday',
    To: 'To',
    days: 'days',
    visits: 'visits',
    uses: 'uses',
    Unlimited: 'Unlimited',
    Perpetual: 'Perpetual',
    'Freeze disabled': 'Freeze disabled',
    'Available any time': 'Available any time',
    // General tab fields
    'Duration in days': 'Duration in days',
    'Max freeze days': 'Max freeze days',
    'Max activation days': 'Max activation days',
    Activation: 'Activation',
    'Card activates at sale': 'Activates at sale',
    'Primary service': 'Primary service',
    'Visits count': 'Visits count',
    'No primary service': 'No primary service yet',
    'Select service': 'Select service',
    Change: 'Change',
    Clear: 'Clear',
    // Discounts tab
    'No discounts yet': 'No discounts yet',
    Target: 'Target',
    'Select target': 'Select target',
    'From time': 'From',
    'To time': 'To',
    'Discount percent': 'Discount, %',
    'Max uses': 'Max uses',
    'Add discount': 'Add discount',
    // Schedule tab
    'No active time windows': 'No active time windows',
    'Add time window': 'Add time window',
    // Hints
    'Card folder hint': 'Folder for organising cards into a tree structure.',
    'Card display name hint':
      'Name the client sees everywhere the card is shown to them. Empty = the card name is used.',
    'Receipt name': 'Receipt name',
    'Receipt name hint':
      'Line name on the fiscal receipt. Empty = the name above is used.',
    'Business direction hint':
      'P&L segment the revenue from this card falls into.',
    'Card price hint':
      'Card price at sale. Snapshotted into ClientCard.purchased_price_cents — already-sold cards keep the previous price.',
    'Card duration hint': 'Validity period counted from the activation moment.',
    'Card max freeze days hint':
      'Total number of freeze days. Empty = freezing is disabled.',
    'Card max activation days hint':
      'Days the client has to activate the card after the purchase. Empty = the card activates at sale. Otherwise it activates on the first use, manually, or automatically once the deadline is reached.',
    'Card primary service hint':
      'The card primary service. These terms are snapshotted on every sale — edits only affect future sales.',
    'Card must grant something hint':
      'A card must contain a primary service or at least one discount.',
    'Card discounts tab hint':
      'Discounted services. Snapshotted at sale — already-sold cards are unaffected by later template edits. Discounts auto-apply in POS when a matching service is added to the cart.',
    'Card discount target hint':
      'A service-specific discount overrides a folder discount. If several cards discount the same service — the largest one applies.',
    'Card discount percent hint':
      'Discount as a percent of the service price. 100% = fully free (shown as USE on the client page); 0% = no discount.',
    'Card discount max uses hint':
      'How many times the client may use this discount via the card. Empty = unlimited within the validity period.',
    'Card schedule tab hint':
      'When the card is active. Time windows are evaluated at use time against the current card — changing them affects active client cards.',
    'Card selling permissions hint':
      'Who among the staff can sell this card. If empty — everyone with the sell permission.',
    'Locations hint':
      'Locations where this card is available for sale. For other locations the card is not shown in POS.',
    // Online tab
    Online: 'Online',
    'Card online tab hint':
      'Configure how this card is sold online — as a regular purchase or a subscription. These settings stay editable after the first sale.',
    'Available online': 'Available online',
    'Card available online hint':
      'Offers the card to clients in the online catalog. Stays editable even after the first sale, unlike the card’s contractual terms.',
    'Card kind': 'Online-sale kind',
    'Card kind hint':
      'A regular purchase or a recurring subscription. A subscription can only be deactivated, never converted to a regular card.',
    'Card kind regular': 'Regular',
    'Card kind subscription': 'Subscription',
    'Not available online': 'Not available online',
    'Start service': 'Start service',
    'Card start service hint':
      'Charged to the client once before the subscription begins (optional).',
    'Days for resubscribe': 'Resubscribe days',
    'Card resubscribe days hint':
      'How long after cancellation the client must wait before subscribing again.',
    'Card subscription locked banner':
      'This card is sold as a subscription. It cannot be converted to a regular card — to stop selling it, turn off «Available online».',
    'Card subscription price locked banner':
      'The price of a subscription card cannot be changed — the payment provider keeps charging the amount clients enrolled with. To change the price, archive this card and create a new one.',
    // Schema validation
    'Card subscription duration':
      'A subscription card must be valid for exactly 31 days.',
    'Card time window end after start':
      'End time must be after the start time.',
    'Card must grant something':
      'A card must contain a primary service or at least one discount.',
    'Unlimited card needs duration':
      'An unlimited-visits card needs a fixed validity period.',
    'Card discount cannot target primary service':
      'A discount cannot target the card primary service.',
  },
  uk: {
    'Search folders and cards…': 'Пошук папок та карток…',
    'Expand all': 'Розгорнути все',
    'Collapse tree': 'Згорнути',
    'No results.': 'Нічого не знайдено.',
    'No selection': 'Нічого не вибрано',
    Status: 'Статус',
    'Reset filters': 'Скинути фільтри',
    'Select a folder or card from the tree on the left to see details.':
      'Виберіть папку або картку в дереві ліворуч, щоб побачити деталі.',
    'Create Category': 'Створити папку',
    'Create Root Category': 'Створити кореневу папку',
    'Create Subcategory': 'Створити підпапку',
    'Category name': 'Назва папки',
    'Parent category': 'Батьківська папка',
    'Edit Category': 'Редагувати папку',
    'Create subcategory': 'Створити підпапку',
    Rename: 'Перейменувати',
    'Maximum category depth': 'Досягнуто максимальної глибини вкладеності',
    'Category not empty': 'Папка не порожня',
    'Confirm deletion': 'Підтвердьте видалення',
    'Delete category confirm': 'Видалити цю папку? Цю дію не можна скасувати.',
    'Category created': 'Папку створено',
    'Category updated': 'Папку оновлено',
    'Category archived': 'Папку заархівовано',
    'Category restored': 'Папку відновлено',
    'Category deleted': 'Папку видалено',
    'Move to': 'Перемістити…',
    Move: 'Перемістити',
    'Move Category': 'Перемістити папку',
    'Move Card': 'Перемістити картку',
    'Select destination category': 'Виберіть цільову папку',
    'Cannot move category depth':
      'Неможливо перемістити сюди — буде перевищено максимальну глибину вкладеності',
    'Category moved': 'Папку переміщено',
    'Card moved': 'Картку переміщено',
    Subcategories: 'Підпапки',
    'This category is empty': 'Ця папка порожня',
    'direct cards': 'карток безпосередньо',
    'cards total': 'карток загалом',
    'Drag to reorder': 'Перетягніть, щоб змінити порядок',
    'Add card': 'Додати картку',
    Card: 'Картка',
    Cards: 'Картки',
    'Create Card': 'Створити картку',
    'Edit Card': 'Редагування картки',
    'Card created': 'Картку створено',
    'Card updated': 'Картку оновлено',
    'Card archived': 'Картку заархівовано',
    'Card restored': 'Картку відновлено',
    'Card deleted': 'Картку видалено',
    'Delete card confirm': 'Видалити цю картку? Цю дію не можна скасувати.',
    Category: 'Папка',
    Folder: 'Папка',
    'Business direction': 'Напрямок діяльності',
    'Price change reason': 'Причина зміни ціни',
    'Price history': 'Історія цін',
    'No price changes': 'Змін ціни немає',
    Remove: 'Видалити',
    'Selling permissions': 'Права на продаж',
    'Specify staff member': 'Вказати співробітника',
    'Anyone with sales permission can sell': 'Будь-хто з правом продажу',
    // Tabs
    General: 'Загальне',
    'Discount services': 'Знижки',
    'Who sells': 'Право продажу',
    'Active schedule': 'Розклад дії',
    // Weekdays
    Monday: 'Пн',
    Tuesday: 'Вт',
    Wednesday: 'Ср',
    Thursday: 'Чт',
    Friday: 'Пт',
    Saturday: 'Сб',
    Sunday: 'Нд',
    Weekday: 'День тижня',
    To: 'До',
    days: 'днів',
    visits: 'відвідувань',
    uses: 'використань',
    Unlimited: 'Безлімітно',
    Perpetual: 'Безстрокова',
    'Freeze disabled': 'Заморозка вимкнена',
    'Available any time': 'Доступна будь-коли',
    // General tab fields
    'Duration in days': 'Термін дії, днів',
    'Max freeze days': 'Макс. днів заморозки',
    'Max activation days': 'Макс. днів до активації',
    Activation: 'Активація',
    'Card activates at sale': 'Активується при продажу',
    'Primary service': 'Основна послуга',
    'Visits count': 'Кількість відвідувань',
    'No primary service': 'Основну послугу не вибрано',
    'Select service': 'Вибрати послугу',
    Change: 'Змінити',
    Clear: 'Очистити',
    // Discounts tab
    'No discounts yet': 'Знижок ще немає',
    'Discount target type': 'Тип цілі',
    'Service folder': 'Папка послуг',
    Target: 'Ціль',
    'Select target': 'Вибрати ціль',
    'From time': 'З',
    'To time': 'До',
    'Discount percent': 'Знижка, %',
    'Max uses': 'Макс. використань',
    'Add discount': 'Додати знижку',
    // Schedule tab
    'No active time windows': 'Часові вікна не задані',
    'Add time window': 'Додати часове вікно',
    // Hints
    'Card folder hint':
      'Папка для організації карток у деревоподібну структуру.',
    'Card display name hint':
      'Назва, яку бачить клієнт скрізь, де показується картка. Порожнє = використовується назва картки.',
    'Receipt name': 'Назва в чеку',
    'Receipt name hint':
      'Назва позиції у фіскальному чеку. Порожнє = використовується назва вище.',
    'Business direction hint': 'Напрямок P&L для виручки від цієї картки.',
    'Card price hint':
      'Ціна картки при продажу. Фіксується snapshot в ClientCard.purchased_price_cents — вже продані картки зберігають попередню ціну.',
    'Card duration hint': 'Термін дії картки від моменту активації.',
    'Card max freeze days hint':
      'Сумарна кількість днів заморожування. Порожнє = заморозка заборонена.',
    'Card max activation days hint':
      'Скільки днів у клієнта є на активацію картки після покупки. Порожнє = картка активується при продажу. Інакше вона активується при першому використанні, вручну або автоматично, коли настане дедлайн.',
    'Card primary service hint':
      'Основна послуга картки. Ці умови фіксуються при кожному продажу — зміни впливають лише на майбутні продажі.',
    'Card must grant something hint':
      'Картка повинна містити основну послугу або хоча б одну знижку.',
    'Card discounts tab hint':
      'Додаткові послуги зі знижкою. Фіксуються при продажу — вже продані картки не змінюються при подальших редагуваннях шаблону. Знижки автозастосовуються в POS при додаванні відповідної послуги в кошик.',
    'Card discount target type hint':
      '«Послуга» — конкретна послуга. «Папка послуг» — знижка на всі послуги в папці та її піддеревах (рекурсивно).',
    'Card discount target hint':
      'Знижка на конкретну послугу має пріоритет над знижкою на папку. Якщо у клієнта кілька карток зі знижкою на ту ж послугу — застосовується найбільша.',
    'Card discount percent hint':
      'Розмір знижки у відсотках від ціни послуги. 100% = повністю безкоштовно (з’являється як USE на сторінці клієнта); 0% = знижка не діє.',
    'Card discount max uses hint':
      'Скільки разів клієнт може скористатися знижкою через цю картку. Порожнє = безлімітно протягом терміну дії.',
    'Card schedule tab hint':
      'Коли картка діє. Часові вікна перевіряються при використанні за поточною карткою — їх зміна впливає на активні картки клієнтів.',
    'Card selling permissions hint':
      'Хто з персоналу може продавати цю картку. Якщо порожнє — всі з правом продажу.',
    'Locations hint':
      'Локації, де ця картка доступна для продажу. Для інших локацій картка не відображається в POS.',
    // Online tab
    Online: 'Онлайн',
    'Card online tab hint':
      'Налаштуйте, як ця картка продається онлайн — звичайна покупка чи підписка. Ці налаштування залишаються редагованими після першого продажу.',
    'Available online': 'Доступна онлайн',
    'Card available online hint':
      'Пропонує картку клієнтам в онлайн-каталозі. Залишається редагованою навіть після першого продажу, на відміну від договірних умов картки.',
    'Card kind': 'Тип онлайн-продажу',
    'Card kind hint':
      'Звичайна покупка або рекурентна підписка. Підписку можна лише деактивувати, але не перевести у звичайну.',
    'Card kind regular': 'Звичайна',
    'Card kind subscription': 'Підписка',
    'Not available online': 'Недоступна онлайн',
    'Start service': 'Початкова послуга',
    'Card start service hint':
      'Стягується з клієнта один раз перед початком підписки (необовʼязково).',
    'Days for resubscribe': 'Днів до повторної підписки',
    'Card resubscribe days hint':
      'Скільки днів після скасування клієнт має зачекати перед повторним оформленням підписки.',
    'Card subscription locked banner':
      'Ця картка продається як підписка. Її не можна перевести у звичайну — щоб припинити продаж, вимкніть «Доступна онлайн».',
    'Card subscription price locked banner':
      'Ціну картки-підписки змінити не можна — платіжний сервіс продовжує списувати суму, з якою клієнти оформили підписку. Щоб змінити ціну, архівуйте цю картку і створіть нову.',
    // Schema validation
    'Card subscription duration': 'Картка-підписка має діяти рівно 31 день.',
    'Card time window end after start':
      'Час завершення має бути пізніше за час початку.',
    'Card must grant something':
      'Картка повинна містити основну послугу або хоча б одну знижку.',
    'Unlimited card needs duration':
      'Картка з безлімітом відвідувань потребує фіксованого терміну дії.',
    'Card discount cannot target primary service':
      'Знижка не може діяти на основну послугу картки.',
  },
};
